module.exports = __webpack_public_path__ + "static/img/yidong.3b80cd71.png";